<div class="campaigns">
	<div class="filters">
		<div class="field">
			<label for="date-range">Date</label>
			<p-dropdown [options]="dateRangeOptions" [optionLabel]="'label'" id="date-range" [(ngModel)]="dateRange"></p-dropdown>
		</div>
		<div class="field">
			<label for="email-type">Type</label>
			<p-dropdown [options]="emailTypeOptions" [optionLabel]="'label'" id="email-type" [(ngModel)]="emailType"></p-dropdown>
		</div>
		<div class="field">
			<label for="employer">Employer</label>
			<p-dropdown [options]="employers" [(ngModel)]="selectedEmployer" [optionLabel]="'employerName'" [autoDisplayFirst]="false"></p-dropdown>
		</div>
		<div class="actions">
			<div class="button neutral" (click)="filterCampaigns()">Search</div>
		</div>
	</div>
	<div class="campaign-grid">
		<div class="name header sortable" (click)="sortCampaigns('name')">
			Name
			<span class="sort-icon" [ngClass]="getSortIcon('name')"></span>
		</div>
		<div class="employer header sortable" (click)="sortCampaigns('employer')">
			Employer
			<span class="sort-icon" [ngClass]="getSortIcon('employer')"></span>
		</div>
		<div class="subject header sortable" (click)="sortCampaigns('subject')">
			Subject
			<span class="sort-icon" [ngClass]="getSortIcon('subject')"></span>
		</div>
		<div class="type header sortable" (click)="sortCampaigns('type')">
			Type
			<span class="sort-icon" [ngClass]="getSortIcon('type')"></span>
		</div>
		<div class="start header sortable" (click)="sortCampaigns('start')">
			Start/Execution
			<span class="sort-icon" [ngClass]="getSortIcon('start')"></span>
		</div>
		<div class="status header sortable" (click)="sortCampaigns('status')">
			Status
			<span class="sort-icon" [ngClass]="getSortIcon('status')"></span>
		</div>
		<ng-container *ngFor="let campaign of campaigns">
			<div class="name">
				<a [routerLink]="['/admin', 'campaigns', campaign.campaignID]">{{ campaign.campaignName }}</a><span class="mode-badge" *ngIf="campaign.editorTypeID === 2">HTML</span>
			</div>
			<div class="employer">{{ campaign.employer }}</div>
			<div class="subject">{{ campaign.eMailSubject }}</div>
			<div class="type">{{ campaign.emailTypeDesc }}</div>
			<div class="start">{{ campaign.deliveryDateTime | date : "MM/dd/yyyy" }}</div>
			<div class="status">{{ campaign.campaignStatusDesc }}</div>
		</ng-container>
	</div>
</div>
